// Generated by @kazoohr/webpack

import "whatwg-fetch";
import React from "react";
import loadable from "@loadable/component";

import { Loader } from "@kazoohr/confetti/Loader";
import { Router, Route, Switch } from "@kazoohr/router";

const Component_admin = loadable(() => import("/home/circleci/project/applications/admin/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_awards = loadable(() => import("/home/circleci/project/applications/awards/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_checkins = loadable(() => import("/home/circleci/project/applications/check-ins/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_dashboard = loadable(() => import("/home/circleci/project/applications/dashboard/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_externalfeeds = loadable(() => import("/home/circleci/project/applications/external-feeds/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_feedback = loadable(() => import("/home/circleci/project/applications/feedback/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_goals = loadable(() => import("/home/circleci/project/applications/goals/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_identity = loadable(() => import("/home/circleci/project/applications/identity/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_incentives = loadable(() => import("/home/circleci/project/applications/incentives/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_insights = loadable(() => import("/home/circleci/project/applications/insights/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_lockstep = loadable(() => import("/home/circleci/project/applications/lockstep/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_login = loadable(() => import("/home/circleci/project/applications/login/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_menu = loadable(() => import("/home/circleci/project/applications/menu/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_microsoftoutlook = loadable(() => import("/home/circleci/project/applications/microsoft-outlook/components/MicrosoftOutlook"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_microsoftteams = loadable(() => import("/home/circleci/project/applications/microsoft-teams/components/MicrosoftTeams"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_notifications = loadable(() => import("/home/circleci/project/applications/notifications/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_people = loadable(() => import("/home/circleci/project/applications/people/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_profile = loadable(() => import("/home/circleci/project/applications/profile/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["Profile"]
    });
const Component_recognitions = loadable(() => import("/home/circleci/project/applications/recognitions/components/Recognitions"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_redirect = loadable(() => import("/home/circleci/project/applications/redirect/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_reports = loadable(() => import("/home/circleci/project/applications/reports/components/Routes"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_rewards = loadable(() => import("/home/circleci/project/applications/rewards/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_surveys = loadable(() => import("/home/circleci/project/applications/surveys/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_syncups = loadable(() => import("/home/circleci/project/applications/sync-ups/components/SyncUps"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_talent = loadable(() => import("/home/circleci/project/applications/talent/components"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });
const Component_team = loadable(() => import("/home/circleci/project/applications/team/components/Team"), {
      fallback: <Loader centered />,
      resolveComponent: (module) => module["default"]
    });

export default function CombinedRoutes() {
  return (
    <Router>
      <Switch>
        <Route path="/admin" component={Component_admin} />
        <Route path="/awards" component={Component_awards} />
        <Route path="/check-ins" component={Component_checkins} />
        <Route path="/dashboard" component={Component_dashboard} />
        <Route path="/external-feeds" component={Component_externalfeeds} />
        <Route path="/feedback" component={Component_feedback} />
        <Route path="/goals" component={Component_goals} />
        <Route path="/identity" component={Component_identity} />
        <Route path="/incentives" component={Component_incentives} />
        <Route path="/insights" component={Component_insights} />
        <Route path="/lockstep" component={Component_lockstep} />
        <Route path="/login" component={Component_login} />
        <Route path="/menu" component={Component_menu} />
        <Route path="/microsoft-outlook" component={Component_microsoftoutlook} />
        <Route path="/microsoft-teams" component={Component_microsoftteams} />
        <Route path="/notifications" component={Component_notifications} />
        <Route path="/people" component={Component_people} />
        <Route path="/profile" component={Component_profile} />
        <Route path="/recognitions" component={Component_recognitions} />
        <Route path="/redirect" component={Component_redirect} />
        <Route path="/reports" component={Component_reports} />
        <Route path="/rewards" component={Component_rewards} />
        <Route path="/surveys" component={Component_surveys} />
        <Route path="/sync-ups" component={Component_syncups} />
        <Route path="/talent" component={Component_talent} />
        <Route path="/team" component={Component_team} />
      </Switch>
    </Router>
  )
}
